<template>
    <div class="card">
      <div class="card-body">
        <b-row>
          <b-col lg="8" >
            <h4 class="card-title d-inline-block">{{$t('Licenses')}}</h4>
            <b-form-select v-show="$route.name !== 'My Licenses'"  @change="getLicenses()" size="sm" v-model="filteredCompany" id="sortBySelect" :options="options" class="ml-2 col-md-5">
              <template v-slot:first>
                <option value="" disabled> {{$t('Select a Company')}}</option>
              </template>
            </b-form-select>
          </b-col>
          <b-col  lg="4">
            <b-btn v-show="$store.state.user.data.role === 'System Admin'" class="btn btn-light float-right btn-secondary" style="color:white;text-decoration: none;" @click="getCompanies" >{{$t('Add Licenses')}}</b-btn>
          </b-col>
        </b-row>
        <p class="card-description">
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
              <br>
            </b-col>

          </b-row>
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 70px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <!-- Main table element -->
          <b-table
            sort-icon-left
            show-empty
            hover
            small
            responsive
            :items="licenses"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
            :sort-compare="customCompare"
          >
            <template v-slot:empty="scope">
              <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
            </template>
            <template v-slot:cell(userName)="row">
              <b-link v-if="row.item.userName" class="nav-link" :to="'/users/'+row.item.userId"> {{ row.item.userName }} </b-link>
              <span v-else-if="row.item.status == 'Expired'"></span>
              <b-link v-else @click="fetchUnlicensedUsers(row.item.id)" v-b-modal.modal-user-to-license class="text-secondary">{{$t('Assign to User')}}</b-link>
            </template>

            <template v-slot:cell(companyName)="row">
              <b-link class="nav-link" :to="{name: 'Company', params: {id: row.item.companyId, licensesCategory: row.item.companyId}}">{{ row.item.companyName }} </b-link>
            </template>
            <template v-slot:cell(type)="row">
              <span v-if="row.item.type === 'Manager'">{{$t(row.item.type)}}</span>
              <span v-else>{{$t("Regular User")}}</span>
            </template>
            <template v-slot:cell(expiresIn)="row">
              <label :class="row.item.expiresIn >= 30 ? '' :'text-danger'">{{ row.item.expiresIn }}</label>
            </template>

            <!--<template v-slot:cell(status)="row">-->
              <!--<label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ $t(row.item.status) }}</label>-->
            <!--</template>-->

            <template v-slot:cell(actions)="row" >
              <b-button v-show="$store.state.user.data.role === 'System Admin'" variant="primary" size="sm" class=" btn btn-primary mr-1" @click="setRenewVars(row.item.id, row.item.expiryDate) ">
                {{$t('Renew')}}
              </b-button>
              <b-button variant="outline-danger" size="sm" @click="deleteLicense(row.item.id, row.item.companyId)">
                {{$t('Delete')}}
              </b-button>
            </template>

            <template v-slot:row-details="row">
              <b-card>
                <ul>
                  <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
                </ul>
              </b-card>
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

          <b-modal
            id="modal-prevent-closing"
            ref="modal"
            title="Add new Licence"
            @show="resetModal"
            @hidden="resetModal"
            @ok="submitLicences"
            okVariant="light"
            ok-title-html="<span style='color:white;'>Submit</span>"
            header-bg-variant="light"
            header-text-variant="white"
          >
            <form ref="form">
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 160px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
              <b-form-group v-if="$route.name !== 'My Licenses'" id="input-group-4" label="Company:" label-for="input-4">
                <b-form-select
                  id="input-4"
                  size="sm"
                  v-model="newLicence.companyId"
                  :options="companies"
                  :state="$v.newLicence.companyId.$dirty ? !$v.newLicence.companyId.$error : null"
                ></b-form-select>
                <b-form-invalid-feedback id="input-7-live-feedback">
                  {{$t('This is a required field')}}.
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                :label="$t('License Expiry Date')"
                label-for="name-input"
              >
                <b-form-input
                  id="name-input"
                  type="date"
                  v-model="newLicence.expiryDate"
                  :state="$v.newLicence.expiryDate.$dirty ? !$v.newLicence.expiryDate.$error : null"
                ></b-form-input>
                <b-form-invalid-feedback id="input-5-live-feedback">
                  {{$t('This is a required field')}}.
                </b-form-invalid-feedback>
              </b-form-group>
              <b-form-group
                :label="$t('Number of Licences')"
                label-for="name-input"
              >
                <b-form-input
                  id="name-input"
                  v-model="newLicence.quantity"
                  :state="$v.newLicence.quantity.$dirty ? !$v.newLicence.quantity.$error : null"
                ></b-form-input>
                <b-form-invalid-feedback id="input-5-live-feedback">
                  {{$t('This is a required field. Must be greater than 0')}}
                </b-form-invalid-feedback>
              </b-form-group>
                <b-form-group
                  :label="$t('Licence Type')"
                  label-for="name-input"
                >
                  <b-form-select
                    id="input-4"
                    size="sm"
                    v-model="newLicence.type"
                    :options="licenseTypes"
                  ></b-form-select>
              </b-form-group>
            </form>
          </b-modal>
          <b-modal
            id="modal-renew-license"
            ref="modal"
            title="Renew Licence"
            @show="resetRenewModal"
            @hidden="resetRenewModal"
            @ok="renewLicense"
            okVariant="light"
            ok-title-html="<span style='color:white;'>Submit</span>"
            header-bg-variant="light"
            header-text-variant="white"
          >
            <form ref="form">
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 100px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
              <h4>{{$t('License last expiry date')}}: {{licensedExpiredOn}}</h4>
              <b-form-group
                label="Renew Date"
                label-for="name-input"
              >
                <b-form-input
                  id="name-input"
                  type="date"
                  v-model="renewLicenseForm.renewDate"
                  :state="$v.renewLicenseForm.renewDate.$dirty ? !$v.renewLicenseForm.renewDate.$error : null"
                ></b-form-input>
                <b-form-invalid-feedback id="input-5-live-feedback">
                  {{$t('This is a required field')}}
                </b-form-invalid-feedback>
              </b-form-group>
            </form>
          </b-modal>
          <b-modal
            id="modal-user-to-license"
            ref="modal"
            :title="$t('Assign License to a User')"
            @show="resetAssignUserModal"
            @hidden="resetAssignUserModal"
            @ok="assignLicense"
            okVariant="light"
            ok-title-html="<span style='color:white;'>Submit</span>"
            header-bg-variant="light"
            header-text-variant="white"
          >
            <form ref="form">
              <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
                <b-spinner
                  variant="secondary"
                ></b-spinner>
              </div>
              <b-form-group @keydown.native.enter="assignManager" id="input-group-4" label="Select User:" label-for="input-4">
                <b-form-select
                  id="input-4"
                  size="sm"
                  v-model="assignLicenseData.userId"
                  :options="unlicensedUsers"
                  :state="$v.assignLicenseData.userId.$dirty ? !$v.assignLicenseData.userId.$error : null"
                ></b-form-select>
                <b-form-invalid-feedback id="input-7-live-feedback">
                  {{$t('This is a required field')}}
                </b-form-invalid-feedback>
              </b-form-group>
            </form>
          </b-modal>
        </b-container>
      </div>
    </div>

</template>

<script>
import moment from 'moment'
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      licenseTypes: [{text: this.$t('Regular User'), value: null}, {text: this.$t('Manager'), value: 'Manager'}],
      licensedExpiredOn: null,
      renewLicenseForm: {
        companyId: null,
        renewLicenseId: null,
        renewDate: null
      },
      licenses: [],
      filters: [
        {text: this.$t('Expired'), value: 'expired'},
        {text: this.$t('Not Assigned'), value: 'notAssigned'},
        {text: this.$t('Expiring Soon'), value: 'expiringSoon'}
      ],
      filteredCompany: '',
      loading: false,
      licenseFilter: '',
      unlicensedUsers: [],
      assignLicenseData: {
        userId: ''
      },
      companies: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 20,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      newLicence: {
        companyId: null,
        quantity: 1,
        expiryDate: null,
        companyName: null,
        type: null
      }
    }
  },
  validations: {
    newLicence: {
      expiryDate: {
        required
      },
      quantity: {
        required,
        minValue: 1,
        maxValue: 30
      },
      companyId: {
        required
      }
    },
    renewLicenseForm: {
      renewDate: {
        required
      }
    },
    assignLicenseData: {
      userId: {
        required
      }
    }
  },
  computed: {
    fields () {
      var aFields = []
      aFields.push({ key: 'userName', label: this.$t('Assigned User'), sortable: false })
      if (this.$store.state.user.data.role === 'System Admin') {
        aFields.push({ key: 'companyName', label: this.$t('Company'), sortable: true })
      }
      aFields.push({key: 'type', label: this.$t('Type'), sortable: true})
      aFields.push({ key: 'expiryDate', label: this.$t('Expires On'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'expiresIn', label: this.$t('Remaining Days'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })
      // aFields.push({ key: 'status', label: this.$t('Status'), sortable: true })
      if (this.$store.state.user.data.role === 'System Admin') {
        aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })
      }
      return aFields
    },
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    options () {
      // This could be simplified if the select was it's own component.
      return this.$store.state.companies.map(f => {
        return { text: f.name, value: f.id }
      })
    }
  },
  mounted () {
    if (this.$route.params.companyId) {
      this.filteredCompany = this.$route.params.companyId
      this.getLicenses()
    } else if (this.$route.name === 'My Licenses') {
      this.filteredCompany = this.$store.state.user.data.companyId
      this.getLicenses()
    } if (this.$store.state.licensesCategory) {
      this.filteredCompany = this.$store.state.licensesCategory
      this.getLicenses()
      this.$store.state.licensesCategory = null
    }

    if (this.$store.state.companies.length === 0) {
      this.$store.dispatch('fetchCompanies')
    }
  },
  methods: {
    customCompare (a, b, key) {
      if (['expiryDate', 'createdAt'].includes(key)) {
        var aDate = moment(a[key], 'DD/MM/YYYY kk:mm')
        var bDate = moment(b[key], 'DD/MM/YYYY kk:mm')
        if (aDate.isValid && bDate.isValid) {
          if (aDate < bDate) {
            return -1
          } else if (aDate > bDate) {
            return 1
          } else {
            return 0
          }
        }
        return null
      } else {
        // Let b-table handle sorting other fields (other than `date` field)
        return false
      }
    },
    getLicenses () {
      // var self = this
      // console.log(this.filteredCompany)
      this.totalRows = 0
      var self = this
      self.licenses = []
      var licenses = this.$firebase.firestore().collection('companies').doc(this.filteredCompany).collection('licenses')
      licenses.get().then(function (querySnapshot) {
        querySnapshot.forEach(function (doc) {
          var licenseData = doc.data()
          licenseData.id = doc.id
          if (licenseData.createdAt != null) {
            licenseData.createdAt = moment(String(licenseData.createdAt.toDate())).format('DD/MM/YYYY kk:mm')
          }
          if (licenseData.expiryDate != null) {
            licenseData.expiresIn = self.expiryDate(licenseData.expiryDate)
            var expiration = moment(licenseData.expiryDate.toDate(), 'DD/MM/YYY')
            var currentDate = moment()
            if (moment(expiration).isBefore(currentDate, 'days')) {
              licenseData.status = 'Expired'
            } else {
              licenseData.status = 'Active'
            }
            licenseData.expiryDate = moment(String(licenseData.expiryDate.toDate())).format('DD/MM/YYYY')
          }
          self.licenses.push(licenseData)
        })
        self.totalRows = self.licenses.length
      })
    },
    setRenewVars (id, expiryDate) {
      this.$bvModal.show('modal-renew-license')
      this.renewLicenseForm.renewLicenseId = id
      this.renewLicenseForm.companyId = this.filteredCompany
      this.licensedExpiredOn = expiryDate
    },
    assignLicense (e) {
      e.preventDefault()
      var self = this
      this.$v.assignLicenseData.$touch()
      if (this.$v.assignLicenseData.$anyError) {
        return
      }
      this.loading = true

      var user = this.unlicensedUsers.find(m => m.value === this.assignLicenseData.userId)
      this.assignLicenseData.userName = user.text
      this.assignLicenseData.companyId = this.filteredCompany
      const createUser = this.$firebase.functions().httpsCallable('assignLicenseToUser')
      createUser(this.assignLicenseData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.getLicenses()
          self.$swal({
            title: self.$t('User Linked with License!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetModal () {
      this.newLicence.companyId = null
      this.newLicence.expiryDate = null
      this.newLicence.quantity = 1
      this.newLicence.type = null
      this.$v.$reset()
    },
    fetchUnlicensedUsers (id) {
      // setting selected license
      this.assignLicenseData.licenseId = id
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', self.filteredCompany).get().then(function (users) {
        self.unlicensedUsers = [{text: self.$t('Select User'), value: ''}]
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName

          var userLicenseIndex = self.licenses.findIndex(l => l.userId === user.id)
          if (userLicenseIndex === -1) {
            self.unlicensedUsers.push({value: user.id, text: name})
          }
        })
      })
    },
    getCompanies () {
      var self = this
      if (this.$route.name === 'My Licenses') {
        this.newLicence.companyId = this.$store.state.user.data.companyId
      } else {
        this.$store.state.companies.forEach(function (company) {
          self.companies.push({text: company.name, value: company.id})
        })
      }
      this.$bvModal.show('modal-prevent-closing')
    },
    submitLicences (e) {
      e.preventDefault()

      this.$v.newLicence.$touch()
      if (this.$v.newLicence.$anyError) {
        return
      }
      this.loading = true
      let self = this
      if (this.$route.name === 'My Licenses') {
        this.newLicence.companyName = this.$store.state.company.name
      } else {
        this.newLicence.companyName = this.companies.find(x => x.value === self.newLicence.companyId).text
      }

      const createLicenses = this.$firebase.functions().httpsCallable('createLicenses')
      createLicenses(this.newLicence).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          if (self.filteredCompany !== '') {
            self.getLicenses()
          }
          // self.$store.dispatch('fetchLicenses', self.filteredCompany)
          self.$swal({
            title: self.$t('Licences Created!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    resetAssignUserModal () {
      this.assignLicenseData.userId = ''
      this.$v.$reset()
    },
    resetRenewModal () {
      this.renewLicenseForm.renewDate = ''
      this.$v.$reset()
    },
    expiryDate (dateString) {
      var expiration = moment(dateString.toDate(), 'DD/MM/YYY')
      var currentDate = moment()
      return moment(expiration).diff(currentDate, 'days')
    },
    deleteLicense (id, companyId) {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this license. This action cannot be undone.'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: 'Confirm',
          centered: true
        })
        .then(value => {
          if (value) {
            self.loading = true
            const deleteLicense = self.$firebase.functions().httpsCallable('deleteLicense')
            deleteLicense({id: id, companyId: companyId}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.getLicenses()
                self.$swal({
                  title: self.$t('Licence Deleted!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
        .catch(err => {
          // An error occurred
          console.log(err)
        })
    },
    renewLicense (e) {
      e.preventDefault()
      this.$v.renewLicenseForm.$touch()
      if (this.$v.renewLicenseForm.$anyError) {
        return
      }
      this.loading = true
      let self = this
      const renewLicense = this.$firebase.functions().httpsCallable('renewLicense')
      renewLicense(this.renewLicenseForm).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.getLicenses()
          self.$swal({
            title: self.$t('Licence Renewed!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Licenses.vue